import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DialogModule } from 'primeng/dialog';

import { Header } from '../header/header';
import { Tour, TOUR_SKIPPED_KEY } from '../../shared/tour/tour';
import { UserStore } from '../../shared/services/user-store';
import { AccountEndpoint } from '../../core/api/services/account-endpoint';

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, Header, DialogModule, Tour],
  templateUrl: './shell.html'
})
export class Shell implements OnInit {
  private userStore = inject(UserStore);
  private accountEndpoint = inject(AccountEndpoint);

  readonly showTour = signal(false);

  ngOnInit(): void {
    this.accountEndpoint.getMe().subscribe(user => {
      this.userStore.setCurrentUser(user);
      if (!user.onboardingCompleted && !localStorage.getItem(TOUR_SKIPPED_KEY)) {
        this.showTour.set(true);
      }
    });
  }
}
